export const ERROR_MESSAGE = "Something went wrong";

//common validation 

export const onlyAlphabets = {
    value: /^[A-Za-z]+$/,
    message: 'Please enter only alphabets',
};

export const onlyAlphabetsandSpaces = {
    value: /^[A-Za-z\s]+$/, // Include \s for space character
    message: 'Please enter only alphabets',
};


export const isValidTemplateName = {
    // Regular expression to match lowercase letters, numbers, and underscores only
    value: /^[a-z0-9_]+$/,
    message: 'Allows only lower case characters, numbers and underscores',
}

export const onlyNumbers = {
    value: /^[0-9]+$/,
    message: 'Please enter only numbers',
}
export const onlyNumbersandSpaces = {
    value: /^[0-9\s]+$/,
    message: 'Please enter only numbers',
}

export const onlyAlphaNumeric = {
    value: /^[a-zA-Z0-9]+$/,
    message: 'Please enter only numbers and alphabets',
};
export const onlyAlphaNumericSpaces = {
    value: /^[a-zA-Z0-9\s]+$/,
    message: 'Please enter only numbers and alphabets',
};

export const noSpacesValidation = (value) => {
    return !/\s/.test(value) || "Spaces are not allowed.";
};

export const noEmptySpacesValidation = (value) => {
    return value.trim().length > 0 || "Input cannot be only spaces.";
};


export const createPattern = (allowedSpecialChars) => {  //allows  special characters as per the requirements along with alphanumeric values
    // Escape special characters in the allowedSpecialChars string
    const escapedSpecialChars = allowedSpecialChars.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
    const pattern = new RegExp(`^[a-zA-Z0-9${escapedSpecialChars} ]+$`);
    const message = `Please enter only numbers, alphabets and ${allowedSpecialChars}`;
    return { value: pattern, message: message };
};

export const MaxLengthValidation = (maxLength) => ({
    value: maxLength,
    message: `Maximum length exceeded. Maximum ${maxLength} characters allowed.`,
});
export const MinLengthValidation = (minLength) => ({
    value: minLength,
    message: `Minimum length is not reached. Minimum ${minLength} characters allowed.`,
});

export const emailValidation = {
    value: /^\S+@\S+\.\S+$/,
    message: 'Please enter a valid email address',

};

export const passwordPattern = {
    value: /^(?=.*[a-zA-Z])(?=.*\d).{6,}$/,
    message: "Password must be at least 6 characters long and include at least one letter and one number.",
};


export const usernameValidations = {
    maxLength: MaxLengthValidation(150),
    minLength: MinLengthValidation(8),
    pattern: {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Invalid email format",
    },
}
export const passwordValidations = {
    maxLength: MaxLengthValidation(15),
    minLength: MinLengthValidation(6),
    pattern: {
        value:
            /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{6,}$/,
        message:
            "Password must contain at least 6 characters, including at least one uppercase letter, one lowercase letter, one number, and one special character.",
    },
}

export const trimValidation = (message = "Field cannot be empty or just spaces") => ({
    validate: (value) => value.trim() !== "" || message,
});

export const customStyles = {

    headRow: {
        style: {
            // backgroundColor: '#000',
            color: '#fff',
            border: '1px solid rgb(70,79,91)',
        },
    },
    headCells: {
        style: {

            borderLeft: '1px solid rgb(70,79,91)',
            borderRight: '1px solid rgb(70,79,91)',

            color: '#fff',
        },
    },

    cells: {
        style: {
            borderBottom: '1px solid rgb(70,79,91)',
            borderLeft: '1px solid rgb(70,79,91)',
            borderRight: '1px solid rgb(70,79,91)',
        },
    },
    select: {
        style: {
            backgroundColor: '#212336',  
            color: '#ffffff',
        },
    },
    pagination: {
        style: {
            backgroundColor: '#212336', // or your desired bg
            color: '#fff',           // text color
        },
    },

};

export const createThemeData =  {
     
        text: {
            primary: '#fff',
            secondary: '#fff',
        },
        background: {
            default: '#212336',
        },
        context: {
            background: '#cb4b16',
            text: '#FFFFFF',
        },
        divider: {
            default: 'transparent',
        },
        button: {
            default: '#2aa198',
            hover: 'rgba(0,0,0,.08)',
            focus: 'rgba(255,255,255,.12)',
            disabled: 'rgba(255, 255, 255, .34)',
        },
        sortFocus: {
            default: '#2aa198',
        },
        select: {

            backgroundColor: '#212336',  // Dark dropdown background
            color: '#ffffff',

        },

    
}